import React from 'react';
import { AnimatedClasses } from '../../utils/animatedStyles';
import { GROUP_SEMINAR } from '../../utils/consts';
import { Certificate, CertificateMed } from '../Certificates';
import { useCloseModal } from './hooks/useCloseModal';
import * as Styles from './styles';

interface Props {
  groupId: number;
  closeHandler: () => void;
}

export const CertificateModal: React.FC<Props> = ({ closeHandler, groupId }) => {
  const { refInnWrapper, closeModal } = useCloseModal(closeHandler);

  return (
    <>
      <Styles.ModalOuterWrapperS>
        <Styles.ModalInnerWrapperS style={{ maxWidth: '750px' }} ref={refInnWrapper} className={AnimatedClasses.zoomIn}>
          <div style={{ padding: '5px', textAlign: 'right' }}>
            <i style={{ cursor: 'pointer', fontSize: '25px' }} className="bi bi-x" onClick={closeModal} />
          </div>
          {groupId === GROUP_SEMINAR.MED ? <CertificateMed /> : <Certificate />}
        </Styles.ModalInnerWrapperS>
      </Styles.ModalOuterWrapperS>
    </>
  );
};
